function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, Dropdown, Menu, Row, Col } from 'antd';
import { CodeOutlined, DownOutlined } from '@ant-design/icons';
import { determineHost } from '@cryptosheets/util';
import { output } from '../_helpers';
export default function RequestButton(_ref) {
  var {
    id,
    type,
    htmlType,
    icon,
    block,
    loading,
    onClick,
    buttonText,
    handleOutputClick
  } = _ref;
  var [host, setHost] = useState('web');
  var [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    function getAndSetHost() {
      return _getAndSetHost.apply(this, arguments);
    }

    function _getAndSetHost() {
      _getAndSetHost = _asyncToGenerator(function* () {
        var host = yield determineHost();
        var config = output({
          data: {}
        });

        var menus = _.reduce(Object.keys(config), function (result, key) {
          var {
            env
          } = config[key];
          var btnText = config[key].buttonText;
          var i = config[key].icon;

          if (env.includes(host)) {
            var element = /*#__PURE__*/React.createElement(Menu.Item, {
              key: key,
              icon: i
            }, btnText);
            result.push(element);
          }

          return result;
        }, []);

        setHost(host);
        setMenuItems(menus);
      });
      return _getAndSetHost.apply(this, arguments);
    }

    getAndSetHost();
  }, []);
  var buttonProps = {
    id,
    type,
    icon,
    htmlType,
    block,
    loading,
    onClick
  };
  var menu = /*#__PURE__*/React.createElement(Menu, {
    onClick: handleOutputClick
  }, menuItems);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(Button, buttonProps, buttonText)), menuItems.length > 1 && /*#__PURE__*/React.createElement(Col, {
    flex: "none"
  }, /*#__PURE__*/React.createElement(Dropdown.Button, {
    id: "request-button-dropdown",
    type: "primary",
    overlay: menu,
    icon: /*#__PURE__*/React.createElement(DownOutlined, null)
  })));
}